// extracted by mini-css-extract-plugin
module.exports = {"menusmain":"menus_menusmain__1o0Tj","totalCount":"menus_totalCount__2uISL","active":"menus_active__3UtCC"};